import { BigHeading, FormContainer, FourContainer, GreenButton, Heading, ListContainer, NavigationContainer, NavigationSideButton, NavigationSideContainer, NavigationToggleButton, OtherPageContainer, RedButton, SearchingBoxContainer, SearchingListContainer, SidebarContainer, SidebarContainerItem, StyledTextField, StyledTextFieldForOtherPage, TextxContainer } from "../assets/style";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { ReactNode, useContext, useEffect, useRef, useState } from "react";
import ReactLoading from "react-loading";
import { useLazyGetUsersQuery } from "../features/users/usersApiSlice";
import MainContent from "./MainContent";
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, InputAdornment, Pagination, PaginationItem, Stack, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import React from "react";
import { useDeleteUserMutation, useLazyGetAllUserQuery, useLazyGetUserQuery, useInsertUserMutation } from "../features/managePermission/managePermissionApiSlice";
import { DataGrid, GridColDef, GridComparatorFn, GridSortDirection, GridSortModel, gridPageCountSelector, gridPageSelector, gridPaginationSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import { GlobalStateContext } from "../store/GlobalState";


const ManagePermission = () => {
    var rowCount = 0;
    const [insertUser, setInsertUser] = useState('')
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [tableContent, setTableContent] = useState<ReactNode>(null);
    const [getUser, userList] = useLazyGetUserQuery();
    const [getAllUser, allUserList] = useLazyGetAllUserQuery();
    const [sortBy, setSortBy] = useState('');
    const [direction, setDirection] = useState('');
    const [userCounter, setUserCounter] = useState(0);
    const [deleteUser] = useDeleteUserMutation();
    const [insertedUser] = useInsertUserMutation();
    const navigate = useNavigate();
    const globalState = useContext(GlobalStateContext);

    // useEffect(() => {
    //     // console.log("effect in main Remain table")
    //     handleTableData()
    //     handleUserData()
    // }, [userCounter, searchQuery]);

    useEffect(() => {
        handleTableData()
        handleUserData()
    }, [userCounter]);

    const handleTableData = async () => {
        setIsLoading(true)
        try {
            if (globalState.token) {
                // await getRFIDQuery(date).then((data) => {
                //     if (data.error) {
                //         navigate('/main')
                //     }
                // });
                // await getRFIDQuery(date)
                await getUser().unwrap()
            }
        } catch (error) {
            // setIsLoading(false);
            alert('An error occurred. Please refresh (F5) or login again.');
            localStorage.setItem('token', '');
            globalState.setToken('');
            navigate("/");
        } finally {
            setIsLoading(false); // Set isLoading to false when loading or updating is completed or when an error occurs
        }
    }

    const handleUserData = async () => {
        setIsLoading(true)
        try {
            if (globalState.token) {
                // await getRFIDQuery(date).then((data) => {
                //     if (data.error) {
                //         navigate('/main')
                //     }
                // });
                // await getRFIDQuery(date)
                await getAllUser().unwrap()
            }
        } catch (error) {
            // setIsLoading(false);
            alert('An error occurred. Please refresh (F5) or login again.');
            localStorage.setItem('token', '');
            globalState.setToken('');
            navigate("/");
        } finally {
            setIsLoading(false); // Set isLoading to false when loading or updating is completed or when an error occurs
        }
    }

    useEffect(() => {
        if (userList.isSuccess) {
            const responseData = userList.data;
            const header: GridColDef[] = [
                { field: 'staffId', headerName: 'Staff ID', width: 300 },
                { field: 'name', headerName: 'Name', width: 300 },
                { field: 'role', headerName: 'Role', width: 300 },
                { field: 'dept', headerName: 'Department', width: 300 },
                { field: 'action', headerName: 'Action', width: 150, sortable: false, renderCell: (params) => params.value },
            ];

            const filteredData = (responseData as any[]).filter((record: any) => {
                var query = record?.staffId?.toString().includes(searchQuery)
                if (!query)
                    query = record?.name?.toString().includes(searchQuery)
                return query
            });

            const row = filteredData.map((record: any, index: number) => {
                return {
                    id: index + 1 + '.',
                    staffId: record.staffId,
                    name: record.name,
                    role: record.role,
                    dept: record.department,
                    action: (
                        <RedButton
                            variant="contained"
                            onClick={(e) => {
                                handleDeleteUser(record.staffId) // need API
                            }}
                            disabled={handleDelete(record.staffId)}
                        >
                            Delete
                        </RedButton>
                    ),
                };
            });

            rowCount = row.length;

            const sortModel = sortBy && direction ? [{ field: sortBy, sort: direction as GridSortDirection }] : [];

            setTableContent(
                <>
                    <DataGrid
                        sx={{
                            '&>.MuiDataGrid-main': {
                                '&>.MuiDataGrid-columnHeaders': {
                                    borderBottomColor: '#E2E2E2',
                                },

                                '& div div div div >.MuiDataGrid-cell': {
                                    borderBottom: 'none',
                                    borderBottomColor: 'transparent'
                                },
                            },
                            '&>.MuiDataGrid-footerContainer': {

                                borderTopColor: '#E2E2E2',
                            },
                            ".highlight": {
                                bgcolor: "#E2E2E2",
                                "&:hover": {
                                    bgcolor: "#FFFFFF",
                                },
                            },
                            borderColor: 'transparent',
                        }}
                        getRowClassName={(params) => {
                            return params.row.id % 2 === 0 ? "highlight" : "";
                        }}
                        rowHeight={32}
                        columnHeaderHeight={25}
                        rows={row}
                        columns={header}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        slots={{
                            pagination: CustomPagination,
                        }}
                        //pageSizeOptions={[5, 10]}
                        disableColumnMenu
                        sortModel={sortModel}
                        onSortModelChange={(model) => {
                            if (model.length > 0) {
                                const { field, sort } = model[0];
                                setSortBy(field);
                                setDirection(sort as string);
                            } else {
                                setSortBy('');
                                setDirection('');
                            }
                        }}
                    />
                </>
            );
        }
    }, [userList, searchQuery, sortBy, direction, userCounter]);

    const CustomPagination = () => {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);
        const paginationState = useGridSelector(apiRef, gridPaginationSelector);
        return (
            <>
                <Stack direction="row" spacing={2}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {paginationState.paginationModel.pageSize * page + 1} - {" "}
                        {(paginationState.paginationModel.pageSize * page + paginationState.paginationModel.pageSize) > rowCount ?
                            (rowCount + " of ")
                            : (paginationState.paginationModel.pageSize * page + paginationState.paginationModel.pageSize + " of ")}{rowCount}
                    </Box>
                    <Pagination
                        color="primary"
                        count={pageCount}
                        page={page + 1}
                        onChange={(event, value) => apiRef.current.setPage(value - 1)}
                        variant="outlined"
                        shape="rounded"
                        sx={{
                            button: { borderColor: "#E2E2E2" },
                        }}
                        renderItem={(item) => (
                            <PaginationItem
                                // components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                {...item}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "#E2E2E2",
                                        color: "white",
                                        borderColor: "transparent",
                                        fontSize: 16,
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "8px"
                                    }
                                }}
                            />
                        )}
                    />
                </Stack>
            </>
        );
    }
    const handleDelete = (userId: any) => {
        // setDeleteUser(e.target.value); 
        if (userId == '00053' || userId == '03274' || userId == '03354')
            return true;
        else return false;
    }

    const handleDeleteUser = async (userId: any) => {
        // setDeleteUser(e.target.value); 

        await deleteUser(userId);
        setUserCounter(userCounter + 1);
        alert('The permission of staff ' + userId + ' has been deleted.');
    }

    // const handleInsertUser = (event: React.ChangeEvent<{}>, value: string | null) => {
    //     setInsertUser(value || ''); // Update the insertUser state with the selected value or an empty string
    // };
    const handleInsertUser = (event: any, value: any) => {
        setInsertUser(value);
    };

    const handleSubmitInsertUser = async (e: any) => {
        e.preventDefault()

        if (!insertUser)
            alert('Staff Information is Required.')
        else {
            try {
                await insertedUser(insertUser)
            } catch (err) {
                alert(err);
            } finally {
                setInsertUser('');
                setUserCounter(userCounter + 1)
            }
            // await insertedUser(insertUser)
            // if (!foundUser) {
            //     alert('User not found.');
            // }
            // else {
            //     // getUser();
            //     alert('The Staff has been inserted.')
            //     setInsertUser('');
            // }
        }
    }

    const formContainerStyle = {
        width: '800px',
    };

    return (
        <>
            <MainContent type={"manage"} >
                <BigHeading >Manage Permission</BigHeading>
                <SearchingBoxContainer >
                    <br></br>
                    {isLoading && (
                        <ReactLoading className="justify-items-center" type={"bubbles"} color={'#9e9e9e'} height={'5%'} width={'5%'} />
                    )}
                    {!isLoading &&
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '50px' }}>
                            <form onSubmit={handleSubmitInsertUser} >
                                <FormContainer sx={formContainerStyle}>
                                    <div className="w-full xl:order-none">
                                        {allUserList.isSuccess &&
                                            <Stack spacing={2}>
                                                <Autocomplete
                                                    id="insertId"
                                                    freeSolo
                                                    // defaultValue={''}
                                                    defaultValue={null}
                                                    options={allUserList.data || []}
                                                    getOptionLabel={
                                                        (option: any) => {
                                                            if (option == undefined)
                                                                return ""
                                                            else if (typeof (option) == "string")
                                                                return option
                                                            return option.eeNo + ', ' + option.surName + ' ' + option.otherName + ', ' + option.roles + ', ' + option.dept
                                                        }}
                                                    // value={insertUser ? insertUser : ""}
                                                    value={insertUser}
                                                    renderInput={(params) =>
                                                        <TextField {...params} label="Staff Information"
                                                            // value={insertUser ? insertUser : ""}
                                                            defaultValue={null}
                                                            value={insertUser}
                                                            onChange={(e) => setInsertUser(e.target.value)}
                                                        />

                                                    }
                                                    onChange={handleInsertUser}

                                                />
                                                <GreenButton
                                                    style={{ marginTop: '10px', height: '40px' }}
                                                    variant="contained"
                                                    type="submit"
                                                    onClick={handleSubmitInsertUser}
                                                >
                                                    Insert Staff
                                                </GreenButton>
                                            </Stack>}
                                        {/* <RecordFieldContainer className="w-1/2">*/}
                                    </div>
                                </FormContainer >
                            </form>
                        </div>}
                    <br></br>
                </SearchingBoxContainer>
                <SearchingListContainer>
                    <br></br>
                    {/* <div style={{ display: 'flex', justifyContent: 'center', gap: '50px' }}> */}
                    <ListContainer className="data-table-overide-styles">
                        <Box
                            sx={{
                                backgroundColor: '#FFFFFF',
                                flexGrow: 1,
                                borderRadius: '20px',
                                border: '1px solid #E2E2E2',
                            }}
                        >
                            <StyledTextFieldForOtherPage
                                // defaultValue={'Staff ID / Name'}
                                // variant="outlined"
                                size="small"
                                InputProps={{
                                    sx: { borderRadius: '20px 1px 1px' },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{ color: '#9e9e9e' }} />
                                        </InputAdornment>
                                    ),
                                }}
                                label="Staff ID / Name"
                                onChange={e => setSearchQuery(e.target.value.toUpperCase())}
                            />

                            {isLoading && (
                                <ReactLoading className="justify-items-center" type={"bubbles"} color={'#9e9e9e'} height={'20%'} width={'20%'} />
                            )}
                            {!isLoading && tableContent}
                        </Box>
                    </ListContainer>
                    {/* </div> */}
                    <br></br>
                </SearchingListContainer>
            </MainContent >
        </>
    )
};
export default ManagePermission;